import sanitizeHtml from "sanitize-html";

export const DefaultExcelRichTextAllowedTags: Record<
  string,
  { transformToNewLine: boolean }
> = {
  p: { transformToNewLine: true },
  strong: { transformToNewLine: false },
  i: { transformToNewLine: false },
  em: { transformToNewLine: false },
  u: { transformToNewLine: false },
  ul: { transformToNewLine: false },
  ol: { transformToNewLine: false },
  li: { transformToNewLine: true },
  br: { transformToNewLine: false },
};

export const DefaultExcelAllowedTagsRegexMap: Record<
  string,
  {
    open: RegExp;
    close: RegExp;
  }
> = Object.keys(DefaultExcelRichTextAllowedTags).reduce<
  Record<string, { open: RegExp; close: RegExp }>
>((acc, key) => {
  acc[key] = {
    open: new RegExp(`<${key}[^>]*>`, "gi"),
    close: new RegExp(`</${key}\\s*>`, "gi"),
  };
  return acc;
}, {});

export const DefaultExcelSanitizeHtmlOptions: sanitizeHtml.IOptions = {
  allowedTags: Object.keys(DefaultExcelRichTextAllowedTags),
  allowedAttributes: {},
  transformTags: {
    ol: "ul",
  },
  disallowedTagsMode: "discard",
};
